import { CheckCircleLine, Download } from '@factorialco/factorial-one-react/icons/app'
import {
  BankingEntitiesPaymentStatusEnum,
  PaymentPageRoutesFragment,
} from 'generated/resources/graphql'

import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'
import { ResourceHeadersPropsWithoutActions } from 'modules/core/lib/navigation/types'

import { statusText } from '../../../lib/mappers'

function tagType(
  status: BankingEntitiesPaymentStatusEnum
): 'neutral' | 'info' | 'positive' | 'warning' | 'critical' {
  switch (status) {
    case 'pending_consent':
    case 'init':
      return 'neutral'
    case 'in_progress':
      return 'info'
    case 'rejected':
      return 'critical'
    case 'done':
      return 'positive'
    default:
      return status satisfies never
  }
}

export const buildPaymentHeaderComponentProps = (
  payment: PaymentPageRoutesFragment
): ResourceHeadersPropsWithoutActions => {
  const lastPaymentExecution = payment.paymentExecutions[payment.paymentExecutions.length - 1]
  const totalTransfers = lastPaymentExecution?.transfersConnection.totalCount || 0
  const actions = totalTransfers
    ? [
        {
          label: i18n.t('banking.payments.download_sepa_file'),
          icon: Download,
          key: 'download_sepa_file',
        },
      ]
    : []
  const paymentInProgress = payment.status === 'in_progress'
  if (totalTransfers && paymentInProgress) {
    actions.push({
      label: i18n.t('banking.payments.mark_as_paid'),
      icon: CheckCircleLine,
      key: 'mark_as_paid',
    })
  }
  return {
    title: payment.label ?? '',
    status: {
      label: '',
      text: statusText(payment.status),
      variant: tagType(payment.status),
    },
    secondaryActions: actions,
    metadata: [
      {
        label: i18n.t('banking.payments.detail_total_amount'),
        value: {
          type: 'text',
          content: formatCurrency(payment.amountCents, payment.currency),
        },
      },
      {
        label: i18n.t('banking.payments.detail_total_count'),
        value: {
          type: 'text',
          content: totalTransfers + '',
        },
      },
    ],
  }
}
